/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChatFilter {
    getFixupPrototypeFunction() { return AgentChatFilter.fixupPrototype; }

    static newInstance(model: Partial<AgentChatFilter>): AgentChatFilter {
        let obj = Object.assign(new AgentChatFilter(), model);
        AgentChatFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChatFilter>): AgentChatFilter {
        if (!model) return null;
        return AgentChatFilter.newInstance(<AgentChatFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChatFilter) {
        if (!obj) return;

        models.AgentChatFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChatFilter): boolean {
        Object.setPrototypeOf(obj, AgentChatFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the agent type
     */
    agent_id: string;

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * Name of the chat
     */
    name: string;

    /**
     * Scope of chats to list
     */
    scope: models.AgentChatScope;

}
